export default {"src":"/_next/static/media/gladly.c482ad08.svg","height":30,"width":29,"blurWidth":0,"blurHeight":0};